import { SVGProps } from 'react';

export const PaperPlaneIcon = (props: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.826 2.01992C15.543 1.76192 16.236 2.45492 15.978 3.17117L11.448 15.7539C11.1668 16.5362 10.0665 16.5512 9.76352 15.7764L7.64177 10.3554L2.22077 8.23442C1.44677 7.93142 1.46177 6.83117 2.24327 6.54917L14.826 2.01917V2.01992Z"
      fill="currentColor"
    />
  </svg>
);
